
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseNavBar from "@/components/layout/default/LayoutDefaultNavBar.vue";
import BaseSideBar from "@/components/layout/default/LayoutDefaultSideBar.vue";
import UserService from "@/services/auth/UserService";
import CleverEventPopup from "@/components/CleverEventPopup.vue";
import AlertPainel from "@/components/AlertPainel.vue";

@Component({
  name: 'LayoutDefault',

  components: {
    BaseNavBar,
    BaseSideBar,
    CleverEventPopup,
    AlertPainel
  }
})
export default class LayoutDefault extends Vue {
  private toogleSidebar: Boolean = false;
  private achievements: any = [];
  private painelMessage: any;
  private lengthAchievements: any = 0;
  private pluralAchievements: any = '';
  private nameUser: any = (this.$auth.user().name).split(' ')[0];
  private dismissInfoCountDown: number = 999;
  private loading:boolean = false;
  private userGoal: number = 0;

  // get url location to show info b-alert
  private currentLocation = window.location.pathname

  private async mounted() {

    // const user
    const userService = new  UserService();
    try {
        const response = await userService.getUserMyData();
        // this.painelMessage = (await userService.painelMessage()).body.find(e => e.type === 'alert');

        if(this.$auth.user().profile === "operator" && !this.$auth.user().saas && !response.body.goal){
          this.$store.commit("navBarAlert/DANGER_ALERT", 'Preencha seu objetivo mensal.');
        } else {
          this.userGoal = response.body.goal
        }

        this.loading = true;
    } catch (error) {
      console.log(error);
    }

    const achievements: any = localStorage.getItem('achievements');

    if(achievements && achievements.length) {
      this.achievements = JSON.parse(achievements);
      this.lengthAchievements = this.achievements.length;
      this.pluralAchievements = (this.achievements.length > 1) ? 'as conquistas' : 'a conquista';

      this.$bvModal.show('modal-conquest');

      localStorage.setItem('achievements', '');
    }
  }

  private hideModal() {
    this.$bvModal.hide('modal-conquest');
  }

  public menuControl(){
    this.toogleSidebar = !this.toogleSidebar;
  }

  private warningAlertCountdownHandler(secsUntilDismiss) {
    this.$store.commit('navBarAlert/WARNING_ALERT_COUNTDOWN', secsUntilDismiss);
  }

  private successAlertCountdownHandler(secsUntilDismiss) {
    this.$store.commit('navBarAlert/SUCCESS_ALERT_COUNTDOWN', secsUntilDismiss);
  }

  private dangerAlertCountdownHandler(secsUntilDismiss) {
    this.$store.commit('navBarAlert/DANGER_ALERT_COUNTDOWN', secsUntilDismiss);
  }
}
